module.exports = __webpack_public_path__ + "img/osprey.e62cac47.jpg";